module.exports = __webpack_public_path__ + "static/media/Illus-Fall@2x.c153e526.png";